import type { SupabaseClient } from '@supabase/supabase-js';
import { renderProductsTab } from './tabs/products.js';
import { infoBadge } from '../lib/info-badge.js';
import { helpButtonHtml, wireHelpButtons } from '../lib/help-panel.js';
import { connectionPillHtml } from '../lib/connection-pill.js';

// Standalone-Produktfenster für den Vario-Verkaufskanal-Tab (Slot
// settings.sales-channels.{appId}.tabs → /#/products). Rendert NUR die Produktübersicht
// im neuen Design: Mock-Header (go-eCommerce- + Gambio-Logo, Titel)
// und darunter die Produkt-Oberfläche - bewusst OHNE App-Menü-/Tab-Leiste (die Navigation
// stellt der Vario-Verkaufskanal). Der „Produkte aktualisieren"-Button lebt im Tab-Content
// (renderProductsTab), NICHT im Header - eine Quelle der Wahrheit für embedded + standalone.

interface ProductsPageContext {
  contentEl: HTMLElement;
  supabase: SupabaseClient;
  session: { token: string; tenantId: string; marketplaceKind: string };
  supabaseUrl: string;
}

const HEADER_HTML = `
  <header class="apphead">
    <a class="brand" href="https://www.go-ecommerce.de" target="_blank" rel="noopener" title="go eCommerce">
      <img src="/logo-black.png" alt="go eCommerce" />
    </a>
    <img class="gambio-logo" src="/gambio-logo.png?v=2" alt="Gambio" />
    <span class="hdivider"></span>
    <div class="htitle">
      <div class="heyebrow">Gambio · Produkte</div>
      <h1>Produktübersicht ${infoBadge('Übersicht aller Artikel und ihres Status im Gambio-Shop.')}</h1>
    </div>
    <div class="hactions">${helpButtonHtml('produktuebersicht')}${connectionPillHtml()}</div>
  </header>
`;

export async function renderProductsPage(ctx: ProductsPageContext): Promise<void> {
  ctx.contentEl.hidden = false;

  // Vario gibt diesem Slot via useFullHeight (in main.ts gesendet) die volle Viewport-Höhe.
  // Ancestor-Kette auf 100% legen, damit das Flex-Layout die Höhe füllt und das Grid INTERN
  // scrollt. `.go-products-fullpage` macht den Container zur 100%-Flex-Spalte (CSS im Package).
  document.documentElement.style.height = '100%';
  document.body.style.height = '100%';
  const appEl = document.getElementById('app');
  if (appEl) appEl.style.height = '100%';
  ctx.contentEl.style.height = '100%';
  ctx.contentEl.classList.add('go-products-fullpage');

  await renderProductsTab(
    ctx.contentEl,
    {
      supabase: ctx.supabase,
      session: { token: ctx.session.token, tenantId: ctx.session.tenantId },
      supabaseUrl: ctx.supabaseUrl,
    },
    { headerHtml: HEADER_HTML },
  );

  wireHelpButtons(ctx.contentEl);
}
